import React from "react";

const Slider = ({
  label,
  min = 0,
  max = 100,
  step = 1,
  value,
  onChange,
  defaultValue,
  unit = "",
  formatValue = (v) => `${v}${unit}`,
  className = "",
  disabled = false,
}) => {
  const percent = ((value - min) / (max - min)) * 100;

  const handleDoubleClick = () => {
    if (defaultValue !== undefined && !disabled) {
      onChange(defaultValue);
    }
  };

  return (
    <div className={`space-y-2 font-fira ${className} ${disabled ? "opacity-40" : ""}`}>
      <div className="flex items-center justify-between text-xs">
        <span className="text-muted-foreground font-semibold uppercase tracking-wider">{label}</span>
        <div className="flex items-center space-x-2">
          <span className="text-primary font-bold">{formatValue(value)}</span>
          {defaultValue !== undefined && value !== defaultValue && (
            <button
              onClick={handleDoubleClick}
              disabled={disabled}
              className="text-[10px] text-terminal-cyan hover:underline transition duration-150"
              title="Double click slider or click here to reset to default"
            >
              [RST]
            </button>
          )}
        </div>
      </div>
      
      <div className="relative flex items-center group">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(parseFloat(e.target.value))}
          onDoubleClick={handleDoubleClick}
          disabled={disabled}
          className="w-full h-2 bg-muted rounded-lg appearance-none cursor-pointer focus:outline-none accent-primary border border-border group-hover:border-primary/40 transition duration-150"
          style={{
            background: `linear-gradient(to right, var(--color-primary) ${percent}%, var(--color-muted) ${percent}%)`,
          }}
        />
      </div>
      <div className="flex justify-between text-[9px] text-muted-foreground font-source">
        <span>{formatValue(min)}</span>
        <span>{formatValue(max)}</span>
      </div>
    </div>
  );
};

export default Slider;
